var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	34458: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	74125: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	533: {
		fallback: () => (Promise.all([__webpack_require__.e(965), __webpack_require__.e(458)]).then(() => (() => (__webpack_require__(74965))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-router",
	},
	21055: {
		fallback: () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(21036))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.9.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/telemetry",
	},
	32451: {
		fallback: () => (Promise.all([__webpack_require__.e(72), __webpack_require__.e(358)]).then(() => (() => (__webpack_require__(95093))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^2.31.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "moment",
	},
	43485: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.36",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	73834: {
		fallback: () => (__webpack_require__.e(21).then(() => (() => (__webpack_require__(31021))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.5.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-axios",
	},
	90837: {
		fallback: () => (Promise.all([__webpack_require__.e(124), __webpack_require__.e(125)]).then(() => (() => (__webpack_require__(82124))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "4.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vuex",
	},
	92007: {
		fallback: () => (Promise.all([__webpack_require__.e(443), __webpack_require__.e(477)]).then(() => (() => (__webpack_require__(97443))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/auth",
	},
	93586: {
		fallback: () => (__webpack_require__.e(69).then(() => (() => (__webpack_require__(87069))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.20.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"82": [
		533,
		21055,
		32451,
		43485,
		73834,
		90837,
		92007,
		93586
	],
	"125": [
		74125
	],
	"458": [
		34458
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}